/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ApplyDeviceEquipmentDetails, ApplyDeviceEquipmentDetailsSuccess, ChangeFamilyInformationDialogDimensions, ChangeFamilyInformationDialogDimensionsSuccess, DeleteServiceType, DeleteServiceTypeSuccess, GetAddFamilyInformationDialogType, GetAddFamilyInformationDialogTypeSuccess, GetPdfLocationPath, GetPdfLocationPathSuccess, GetUserCustomImage, GetUserCustomImageSuccess, OpenPdfFile, OpenPdfFileSuccess, SaveFamilyInformationInXml, SaveFamilyInformationInXmlSuccess, SaveServiceType, SaveServiceTypeSuccess, SendClosePopupAction, SendClosePopupActionSuccess, ValidateAndGetData, ValidateAndGetDataSuccess } from "./add-family-information-actions";
import { concatMap, from, map } from "rxjs";
import { FamilyInformationService } from '../../../../../utils/src/lib/sysque-backend/family-information.service';

@Injectable()
export class FamilyInformationEffects {
  constructor(private actions$: Actions, private familyInformationService: FamilyInformationService) { }

  getAddFamilyInformationDialogType$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetAddFamilyInformationDialogType),
      concatMap(action => {
        this.familyInformationService.getAddFamilyInformationDialogType(action.data);
        return from([GetAddFamilyInformationDialogTypeSuccess({ response: 'OK' })]);
      })
    );
  });

  saveFamilyInformationInXml$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SaveFamilyInformationInXml),
      concatMap(action => {
        this.familyInformationService.saveFamilyInformationInXml(action.item);
        return from([SaveFamilyInformationInXmlSuccess({ response: 'OK' })]);
      })
    );
  });

  changeDialogDimensions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ChangeFamilyInformationDialogDimensions),
      concatMap(action => {
        this.familyInformationService.changeDialogDimensions(action.height);
        return from([ChangeFamilyInformationDialogDimensionsSuccess({ response: 'OK' })]);
      })
    );
  });

  getPdfLocationPath$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetPdfLocationPath),
      concatMap(() =>
        this.familyInformationService
          .getPdfLocationPath()
          .pipe(map((data) => data && GetPdfLocationPathSuccess({ response: data })))
      )
    );
  });

  openPdfFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OpenPdfFile),
      concatMap((action) =>
        this.familyInformationService
          .openPdfFile(action.filePath)
          .pipe(map((data) => data && OpenPdfFileSuccess({ response: data })))
      )
    );
  });

  sendClosePopupAction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SendClosePopupAction),
      concatMap(() => {
        this.familyInformationService.sendClosePopupAction();
        return from([SendClosePopupActionSuccess({ response: 'OK' })]);
      })
    );
  });

  saveServiceTypeAction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SaveServiceType),
      concatMap(action => {
        this.familyInformationService.saveServiceType(action.serviceTypeToSave);
        return from([SaveServiceTypeSuccess({ response: 'OK' })]);
      })
    );
  });

  deleteServiceTypeAction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeleteServiceType),
      concatMap(action => {
        this.familyInformationService.deleteServiceType(action.serviceTypeToDelete);
        return from([DeleteServiceTypeSuccess({ response: 'OK' })]);
      })
    );
  });

  getUserCustomImage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetUserCustomImage),
      concatMap((action) =>
        this.familyInformationService
          .getUserCustomImage(action.systemName, action.name)
          .pipe(map((data) => data && GetUserCustomImageSuccess({ response: data })))
      )
    );
  });

  validateAndGetData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValidateAndGetData),
      concatMap(() => 
        this.familyInformationService.validateAndGetData()
          .pipe(map((data) => data && ValidateAndGetDataSuccess({ response: data })))
      )
    );
  });

  applyDeviceEquipmentDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApplyDeviceEquipmentDetails),
      concatMap(action => {
        this.familyInformationService.deviceEquipmentDetailsApplyData(action.item);
        return from([ApplyDeviceEquipmentDetailsSuccess({ response: 'OK' })]);
      })
    );
  });
}
